<template>
  <div class="ui-base-layout-grid">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-base-layout-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(15rem,1fr));
  gap: 1rem;
  padding: 1rem 0;

  :deep(.grid-item) {
    transform: translateZ(0);
  }
  :deep(.grid > *) {
    backface-visibility: hidden;
    > a {
      display: flex;
      flex-direction: column;
      transition: 0.15s ease-in-out;
      span {
        display: inline-block;
        padding: 0.5rem 0;
        font-weight: bold;
      }
    }
  }
}
</style>
